import { useAutoneTranslation } from '@autone/translations';
import {
  createColumnLoadingGuards,
  DataTableCellContent,
  DataTableCellTitle,
  type DataTableLoadingObject,
  LongText,
} from '@autone/ui';
import { type ColumnHelper } from '@tanstack/react-table';

import { type APP_NAME } from '../../../consts';

const COLUMN_ID = 'location_cluster' as const;

export type LocationClusterColumnId = typeof COLUMN_ID;

interface LocationClusterFields {
  location_cluster: string | null;
}

const { columnCellGuard, accessorFnGuard } =
  createColumnLoadingGuards<LocationClusterFields>();

export const createLocationClusterColumn = <
  T extends LocationClusterFields | DataTableLoadingObject,
>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor(
    accessorFnGuard((row) => row.location_cluster),
    {
      id: COLUMN_ID,
      size: 200,
      header: function LocationClusterHeader() {
        const { common } = useAutoneTranslation<typeof APP_NAME>();
        return (
          <DataTableCellContent>
            <DataTableCellTitle className="uppercase font-medium whitespace-normal">
              {common.withCustomer('$location-cluster')}
            </DataTableCellTitle>
          </DataTableCellContent>
        );
      },
      cell: (ctx) =>
        columnCellGuard({
          ctx,
          renderCell: function LocationClusterCell({ getValue }) {
            const { common } = useAutoneTranslation<typeof APP_NAME>();
            const cluster = getValue();

            return (
              <DataTableCellContent>
                <DataTableCellTitle>
                  {cluster ? (
                    <LongText value={getValue()} maxLength={30} />
                  ) : (
                    common('na')
                  )}
                </DataTableCellTitle>
              </DataTableCellContent>
            );
          },
        }),
    },
  );
